import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "trigger"]

  connect() {
    this.hide = this.hide.bind(this)
    this.closeWithEscape = this.closeWithEscape.bind(this)
    document.addEventListener("click", this.hide)
    document.addEventListener("keydown", this.closeWithEscape)
    this.close()
  }

  disconnect() {
    document.removeEventListener("click", this.hide)
    document.removeEventListener("keydown", this.closeWithEscape)
  }

  openPanel(event) {
    event.preventDefault()
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
    this.triggerTarget.setAttribute("aria-expanded", (!this.menuTarget.classList.contains("hidden")).toString())
  }

  hide(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  closeWithEscape(event) {
    if (event.key === "Escape") this.close()
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "false")
  }
}
